import React from "react";
import Spinner from "./Spinner";
import { NoResultsFoundMessage } from "./NoResultsFound";

const RenderContentStatus = ({
  loading,
  results,
  noResultsFoundMessage = "No results found",
}: {
  loading: boolean;
  results: number;
  noResultsFoundMessage: string;
}): React.JSX.Element | null => {
  if (loading) return <Spinner />;
  if (results) return <></>;
  if (!loading && !results)
    return <NoResultsFoundMessage message={noResultsFoundMessage} />;
  return null;
};
export default RenderContentStatus;
